module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av529-4cb6303567d6ea323b157a9ca40f9542.jpg";